import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Inputs {
  contentGroupId: string;
  listId: string;
  dates: Date[];
  title: string;
  onlySave?: boolean;
}

interface Props {
  agendaId?: string;
	onSuccess?: (agenda, variables) => void;
  onError?: (res: AxiosError) => void;
}

export const useSaveAgenda = ({
  agendaId,
	onSuccess,
  onError
}: Props) => {
  const queryClient = useQueryClient();
	const {
		mutate: onSaveAgenda,
    variables,
    ...rest
	} = useMutation({
		mutationFn: async ({ onlySave, dates, ...rest }: Inputs) => {
      const [startsAt, endsAt] = dates;
      const data = { ...rest, startsAt, endsAt };

      if (agendaId) 
        return await axios.patch(`/agendas/${agendaId}`, data);
      return await axios.post('/agendas', data);
		},
		onSuccess: ({ data: { agenda } }) => {
      if (agendaId)
        queryClient.invalidateQueries({ queryKey: ['agenda', agendaId] });
      if (onSuccess)
        onSuccess(agenda, variables);
    },
    onError
	});

	return { onSaveAgenda, variables, ...rest };
};
